<template>
	<div class="def-height"></div>
</template>

<script>
	export default {
		data() {
			return {
			}
		},
		methods: {
		}
	}
</script>

<style lang="scss" scoped>
	.def-height{
		height: 44px;
	}
</style>



// WEBPACK FOOTER //
// src/components/public/defHn.vue